<template>
  <div class="container container--login">
    <div class="container__wrapper">
      <div class="login">
        <div class="login__lead">
          <div class="brand">
            <img src="/img/billstash-logo-full.svg">
          </div>
          <div class="login__context">
            <h2>Stacks</h2>
            <h1>Queue Management System</h1>
          </div>
          <div class="data-group data-group--v">
            <span class="data">© Stacks by Revlv 2021</span>
          </div>
        </div>
        <div class="login__stage">
          <div class="login__form">
            <form
              class="form"
              method="POST"
              @submit.prevent="login"
            >
              <div
                v-if="$page.props.flash.error"
                class="notice notice--red"
              >
                <div class="notice__icon">
                  <i class="icon icon-exclamation-mark" />
                </div>
                <div class="notice__content">
                  <p>{{ $page.props.flash.error }}</p>
                </div>
              </div>
              <div class="form-group">
                <label for="" class="form-label">Username or Email</label>
                <div class="form-input-group">
                  <span class="form-input-group__icon">
                    <i class="icon icon-circle-10" />
                  </span>
                  <input
                    v-model="form.username"
                    type="text"
                    name="email"
                    class="form-input u-br"
                    placeholder="youremail@example.com"
                  >
                </div>
              </div>
              <div class="form-group">
                <label for="" class="form-label">Password</label>
                <div class="form-input-group">
                  <span class="form-input-group__icon">
                    <i class="icon icon-password" />
                  </span>
                  <input
                    id="password"
                    v-model="form.password"
                    type="password"
                    name="password"
                    class="form-input u-br"
                    placeholder="Password"
                  >
                </div>
              </div>
              <div class="login__form__control">
                <div class="form-check u-br">
                  <input
                    id="remember_login"
                    v-model="form.remember"
                    type="checkbox"
                    class="form-check__input"
                  >
                  <label for="remember_login" class="form-check__label">Keep me signed in</label>
                </div>
                <button-loader :loading="loading">
                  Sign-in
                </button-loader>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonLoader from '@components/shared/ButtonLoader'

export default {
  metaInfo: {
    title: 'Login',
  },
  components: {
    ButtonLoader,
  },
  props: {
    errors: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    form: {
      username: null,
      password: null,
      remember: false,
    },
  }),
  head: () => ({
    title: 'Login',
  }),
  methods: {
    login () {
      this.$inertia.post(this.route('login.attempt'), this.form, {
        onStart: () => this.loading = true,
        onFinish: () => this.loading = false,
      })
    },
  },
}
</script>
